import { IFormatter } from '../FormatterTypes';
import { TEDDisplayTimeHour } from '../Displayers/TEDDisplayTimeHour';
import { TEDParseTimeHour } from '../Parsers/TEDParseTimeHour';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';

class TEDFormatTimeHour implements IFormatter {
  displayer = TEDDisplayTimeHour.getInstance();
  parser = TEDParseTimeHour.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatTimeHour };
